const colors = {
  GREEN_DARK: '#29694D',
  GREEN_BRIGHT: '#2EA243',
  GREEN_LIGHT: '#ABDAB4',
  GREEN_LIGHTEST: '#E3ECE9',
  GRAY_DARK: '#4D4D4F',
  GRAY: '#757575',
  LIGHT: '#009F55',
  RED_BRIGHT: '#ff6f83',
  TRANSPARENT: 'rgba(0,0,0,0)',
  BLACK: '#000',
  WHITE: '#fff',
};

export default colors;


// WEBPACK FOOTER //
// ./src/ui/colors.js